import { useRef, useState } from "react";

import { NavLink } from "react-router-dom";

import { useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  lighten,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography,
  styled,
} from "@mui/material";

import InboxTwoToneIcon from "@mui/icons-material/InboxTwoTone";
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
import AccountBoxTwoToneIcon from "@mui/icons-material/AccountBoxTwoTone";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import AccountTreeTwoToneIcon from "@mui/icons-material/AccountTreeTwoTone";
import PersonIcon from "@mui/icons-material/Person";
import UserService from "src/services/user.service";

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);

function HeaderUserbox() {
  const { user: currentUser } = useSelector((state) => state.auth);

  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Get avatar
  const getAvatarUrl = () => {
    if (currentUser?.avatar) {
      const url = UserService.getAvatarUrl(currentUser.avatar);
      return url;
    }
    return null;
  };

  // Format role name untuk display
  const getDisplayRoleName = (role) => {
    if (!role) return '';
    
    // Handle both string and object role formats
    const roleStr = typeof role === 'string' ? role : (role?.name || '');
    
    const roleMap = {
      'ROLE_ADMIN': 'Administrator',
      'ROLE_WALIDATA': 'Walidata',
      'ROLE_WALIDATA_PENDUKUNG': 'Walidata Pendukung',
      'ROLE_PRODUSEN': 'Produsen Data',
      'ROLE_EKSTERNAL': 'Publik',
    };
    return roleMap[roleStr] || (typeof roleStr === 'string' ? roleStr.replace('ROLE_', '') : roleStr);
  };

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar
          key={currentUser?.avatar || 'no-avatar'}
          variant="rounded"
          alt={currentUser?.username}
          src={getAvatarUrl()}
          sx={{ bgcolor: 'primary.main' }}
        >
          {!currentUser?.avatar && <PersonIcon />}
        </Avatar>

        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">{currentUser.username}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {getDisplayRoleName(currentUser.roles)}
            </UserBoxDescription>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          {
            //<Avatar variant="rounded" alt={user.name} src={user.avatar} />
          }
          <UserBoxText>
            <UserBoxLabel variant="body1">{currentUser.username}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {getDisplayRoleName(currentUser.roles)}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <List sx={{ p: 1 }} component="nav">
          <ListItem button to="/akun/profile/details" component={NavLink}>
            <AccountBoxTwoToneIcon fontSize="small" />
            <ListItemText primary="My Profile" />
          </ListItem>
          {/*
          <ListItem button to="/dashboards/messenger" component={NavLink}>
            <InboxTwoToneIcon fontSize="small" />
            <ListItemText primary="Messenger" />
          </ListItem>
          */}
          <ListItem button to="/akun/profile/settings" component={NavLink}>
            <AccountTreeTwoToneIcon fontSize="small" />
            <ListItemText primary="Account Settings" />
          </ListItem>
        </List>
        <Divider />
        <Box sx={{ m: 1 }}>
          <Button
            color="primary"
            fullWidth
            component={NavLink}
            to="/auth/logout"
          >
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
